export function updateBenefitList(state, list) {
    state.benefits = list
}

export function pushIntoBenefits(state, item) {
    state.benefits.push(item)
}